import { useState, useEffect } from 'react';
import Box from '@mui/material/Box';
import Button from '@material-ui/core/Button';
import Checkbox from '@material-ui/core/Checkbox';
import { Theme } from '@material-ui/core/styles/createTheme';
import createStyles from '@material-ui/core/styles/createStyles';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Typography from '@material-ui/core/Typography';
import { colors } from '../../theme/palette';

const useStyles = makeStyles((theme: Theme) =>
	createStyles({
		pageContainer: {
			display: 'flex',
			justifyContent: 'center',
			alignItems: 'center',
			width: '100%',
			height: '100%',
		},
		container: {
			padding: '24px',
			width: '400px',
			height: '100%',
			background: 'white',
		},
		deleteButton: {
			backgroundColor: colors.redLight,
			color: colors.redDark,
			'&:hover': {
				backgroundColor: colors.redDark,
				color: colors.pureWhite,
			},
		},
		actionBox: {
			display: 'flex',
			alignItems: 'center',
		},
		dismissText: {
			color: colors.grayDark,
		},
	})
);

interface IProps {
	setEditType: (type: 'select' | 'grapes' | 'tiny') => void;
}

export const SelectEditType = ({ setEditType }: IProps) => {
	const classes = useStyles();
	const [hide, setHide] = useState<boolean>(false);

	useEffect(() => {
		const editType = localStorage.getItem('editType');
		if (editType) {
			setEditType(editType as any);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const handleEditType = (editType: string) => {
		if (hide) {
			localStorage.setItem('editType', editType);
		}
		setEditType(editType as any);
	};

	return (
		<div className={classes.pageContainer}>
			<Box className={classes.container}>
				<p style={{ fontSize: '24px', marginBottom: '40px' }}>Select content editing tool</p>
				<div style={{ display: 'flex', gap: '12px', flexDirection: 'column' }}>
					<Button variant="contained" onClick={() => handleEditType('grapes')}>
						GrapesJS
					</Button>
					<Button variant="contained" onClick={() => handleEditType('tiny')}>
						TinyMCE
					</Button>

					<Box className={classes.actionBox}>
						<Checkbox
							color="primary"
							onClick={() => {
								setHide((prevState) => !prevState);
							}}
						/>
						<Typography variant="body2" className={classes.dismissText}>
							Don't ask me this again.
						</Typography>
					</Box>
				</div>
			</Box>
		</div>
	);
};
